import { render, staticRenderFns } from "./AuthButtonConfig.vue?vue&type=template&id=fd2f2068&"
import script from "./AuthButtonConfig.vue?vue&type=script&lang=ts&"
export * from "./AuthButtonConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports